module.exports = __webpack_public_path__ + "images/emoji/eight.e5328b10ebf454dde7f6.png";